var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.6898 21.9567L3.52526 1.16791C2.86858 0.522892 1.81335 0.532341 1.16833 1.18902C0.523313 1.84569 0.532764 2.90093 1.18944 3.54595L22.354 24.3347C23.0106 24.9798 24.0659 24.9703 24.7109 24.3136C25.3559 23.657 25.3465 22.6017 24.6898 21.9567Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.18896 21.9567L22.3535 1.16791C23.0102 0.522892 24.0654 0.532341 24.7104 1.18902C25.3554 1.84569 25.346 2.90093 24.6893 3.54595L3.52478 24.3347C2.8681 24.9798 1.81286 24.9703 1.16785 24.3136C0.522828 23.657 0.53228 22.6017 1.18896 21.9567Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.cdc3eebf5ca8c6bac1335574dfa6e894.svg";
export { ForwardRef as ReactComponent };